import { FC } from 'react';
import FullscreenButtonStyled from './style';
import { Props } from './types';
import DeviceManager from '../../components/util/deviceManager';
const FullscreenButton: FC<Props & { children?: any }> = ({ onClick, isFullscreen }) =>
  !DeviceManager.isMobile() ? (
    <FullscreenButtonStyled onClick={onClick} isFullscreen={isFullscreen}>
      <i className={isFullscreen ? 'fas fa-compress' : 'fas fa-expand'} />
    </FullscreenButtonStyled>
  ) : (
    <></>
  );

export default FullscreenButton;
